import { render } from "./Transactions.vue?vue&type=template&id=de77043c"
import script from "./Transactions.vue?vue&type=script&lang=ts"
export * from "./Transactions.vue?vue&type=script&lang=ts"
script.render = render

export default script